import type { MorphemePanelsToolbarEditAction } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels";
import { useState, type PropsWithChildren } from "react";
import { MorphemePanelsContext } from "#morpheme-panels-context";
import { useMorphemePanelsContextValue } from "#morpheme-panels-context-value";

export function MorphemePanelsContextProvider({
  children,
  ...props
}: PropsWithChildren<Parameters<typeof useMorphemePanelsContextValue>[0]>) {
  const [toolbarEditAction, setToolbarEditAction] = useState<MorphemePanelsToolbarEditAction>(null);
  const [isFlashcardEditPending, setIsFlashcardEditPending] = useState(false);
  const value = useMorphemePanelsContextValue({
    ...props,
    isFlashcardEditPending,
    onFlashcardEditPendingChange: setIsFlashcardEditPending,
    onToolbarEditActionChange: setToolbarEditAction,
    toolbarEditAction,
  });
  return <MorphemePanelsContext.Provider value={value}>{children}</MorphemePanelsContext.Provider>;
}
